/**
 * @generated SignedSource<<92c82bccba7b8dac93c100ac13cc0592>>
 * @relayHash 5d99b273cf0d13a200609bafa4b11e63
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 285b83673a40039f0a275806935f1b1602448c9ed410eaf8a41bcb365fc635fd

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraFieldSchemeAssociatedFieldsInput = {
  nameFilter?: string | null | undefined;
  schemeId: string;
};
export type FieldSchemePageQuery$variables = {
  cloudId: string;
  input: JiraFieldSchemeAssociatedFieldsInput;
};
export type FieldSchemePageQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"AssociatedFieldsTable">;
};
export type FieldSchemePageQuery = {
  response: FieldSchemePageQuery$data;
  variables: FieldSchemePageQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "cloudId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = {
  "kind": "Variable",
  "name": "input",
  "variableName": "input"
},
v2 = [
  {
    "kind": "Variable",
    "name": "cloudId",
    "variableName": "cloudId"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 40
  },
  (v1/*: any*/)
],
v3 = {
  "kind": "ScalarField",
  "name": "id"
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": [
          (v1/*: any*/)
        ],
        "kind": "FragmentSpread",
        "name": "AssociatedFieldsTable"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "FieldSchemePageQuery",
    "selections": [
      {
        "args": (v2/*: any*/),
        "concreteType": "JiraFieldSchemeAssociatedFieldsConnection",
        "kind": "LinkedField",
        "name": "jira_fieldSchemeAssociatedFields",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraFieldSchemeAssociatedFieldsEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "concreteType": "JiraFieldSchemeAssociatedField",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "JiraField",
                    "kind": "LinkedField",
                    "name": "field",
                    "plural": false,
                    "selections": [
                      (v3/*: any*/),
                      {
                        "kind": "ScalarField",
                        "name": "name"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "description"
                      },
                      {
                        "kind": "ScalarField",
                        "name": "typeName"
                      }
                    ]
                  },
                  (v3/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "__typename"
                  }
                ]
              },
              {
                "kind": "ScalarField",
                "name": "cursor"
              }
            ]
          },
          {
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "kind": "ScalarField",
                "name": "hasNextPage"
              },
              {
                "kind": "ScalarField",
                "name": "endCursor"
              }
            ]
          }
        ]
      },
      {
        "args": (v2/*: any*/),
        "filters": [
          "cloudId",
          "input"
        ],
        "handle": "connection",
        "key": "associatedFieldsTable_adminPagesFieldScheme_jira_fieldSchemeAssociatedFields",
        "kind": "LinkedHandle",
        "name": "jira_fieldSchemeAssociatedFields"
      }
    ]
  },
  "params": {
    "id": "285b83673a40039f0a275806935f1b1602448c9ed410eaf8a41bcb365fc635fd",
    "metadata": {},
    "name": "FieldSchemePageQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "64a4cefcd4ceecf4c5a0518dfb791fc0";

import { PreloadableQueryRegistry } from 'relay-runtime';
PreloadableQueryRegistry.set(node.params.id, node);

export default node;
